// extracted by mini-css-extract-plugin
module.exports = {"transaction-setting":"tDYdQyVS4Z","submit-btn":"_1owVG7A0Gb"};